import api from './axiosConfig';

const THROTTLE_MS = 5 * 60 * 1000;
const STORAGE_KEY = 'adminActivityLastPing';

// Records the authenticated admin's last-seen timestamp server-side.
// Fire-and-forget: the backend resolves the account from the auth cookie, so no
// payload is needed, and any failure (including the endpoint not existing yet)
// is swallowed on purpose — activity tracking must never surface to the user or
// block the dashboard. Throttled so reloads/navigation don't spam the backend.
export const trackAdminActivity = (): void => {
  const now = Date.now();
  const last = Number(localStorage.getItem(STORAGE_KEY) ?? 0);
  if (now - last < THROTTLE_MS) {
    return;
  }
  localStorage.setItem(STORAGE_KEY, String(now));
  api.post('/admin-accounts/track-activity').catch(() => {});
};
